const smtPqAboutUsSection = {
    description: {
        color: {
            default: 'gray.900',
            _dark: 'gray.400'
        },
    },
    testimonial: {
        heading: {
            // Text, so the contrast-checked text token (see
            // shared.text.brand). The old dark half, brand.600, was 2.4:1.
            color: {
                default: 'shared.text.brand'
            }
        }
    }
}

export default smtPqAboutUsSection;